//#region Styles
import {
    Part, Row,
    Column, ResumeSection, 
    TitleSection2
} from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import ListDataField from "views/components/Detail/ListDataField/ListDataField";
import DataField from "views/components/Detail/DataField/DataField";
import LocationDataField from "views/components/Detail/LocationDataField/LocationDataField";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import { LOCATION_IDS } from "config/constants";
//#endregion

const ResumeStep2 = ({
    toStep2,
    allCampus,
    modalities,
    locations,
    form
}) => {
    const getModalityName = modalityId => {
        let modalityName = modalities.find(({ id }) => {
            return id === modalityId;
        })?.name || "-";
        if (modalityId === 3)
            modalityName = `Todas las modalidades (${modalityName})`;
        return modalityName;
    }
    const getDataPart = () => {
        const { locationId, place } = form.part1;
        const { modalityId, publicByCampusIds } = form.part2.publicLoad.students;
        const dataParts = [
            [
                { 
                    field: "Ubicación:", 
                    render: (
                        <LocationDataField location={locations.find(({ id }) => id === locationId)}/>
                    ) 
                }
            ],
            [
                {
                    field: "De todos los campus",
                    render: (
                        <ListDataField 
                            data={publicByCampusIds.map((publicCampusId) => {
                                return allCampus.find(({ id }) => id === publicCampusId)?.name || "-";
                            })}
                        />
                    )
                }
            ]
        ];
        const modalityField = {
            field: "Modalidad",
            description: getModalityName(modalityId)
        };
        if (locationId === LOCATION_IDS.ZOOM) {
            dataParts[0].push(modalityField);
        }
        else if (locationId === LOCATION_IDS.PLACE) {
            const { 
                campus, environment
            } = place;
            dataParts[0].splice(1, 0, ...[
                {
                    field: "Campus:",
                    description: campus?.name || "-"
                },
                {
                    field: "Ambiente:",
                    description: environment?.envName || "-"
                },
                {
                    field: "Dirección:",
                    description: environment?.address || "-"
                },
                {
                    field: "Piso:",
                    description: environment?.floor || "-"
                }
            ]);
            dataParts[1].push(modalityField);
        }
        return dataParts;
    }
    return (
        <Part>
            <Row>
                <TitleSection2>Ubicación y público</TitleSection2>
                    <CustomButton
                        variant="quintinary"
                        text="Editar sección"
                        icon={<PenIcon/>}
                        onClick={toStep2}/>
            </Row>
            <ResumeSection>
                <Part direction="row">
                    {getDataPart().map((row, idx1) => {
                        return(
                            <Column
                                key={idx1}
                                gap="20px"
                                width="45%">
                                {row.map((item, idx2) =>{
                                    return (
                                        <DataField 
                                            key={idx2}
                                            {...item}/>
                                    );
                                })}
                            </Column>
                        )
                    })}
                </Part>
            </ResumeSection>
        </Part>
    );
}

export default ResumeStep2;